module.exports = __webpack_public_path__ + "media/images/logo-4d857e993f8ff5fa5cb4539607c7472b.png";